import React from 'react'
import { APILoggerDetail } from '../../models/APILoggerDetail';
import { IntlShape, FormattedMessage } from 'react-intl';
import { SiteDetails } from '../../components/Graphing Functions/GraphUtilityFunctions'
import { GraphTemplate } from '../../models/GraphTemplateModel'
import moment from 'moment'


export const renderTooltip = (
    point: any,
    loggers: APILoggerDetail[],
    intl: IntlShape,
    loggerSiteDetails: SiteDetails[],
    combineY: boolean | null,
    unitsAndValues: GraphTemplate[],
    combinedFlowAUnit: string | null,
    combinedTotalAUnit: string | null,
    combinedConsumptionAUnit: string | null,
    combinedFlowBUnit: string | null,
    combinedTotalBUnit: string | null,
    combinedConsumptionBUnit: string | null,
    combinedPressureCUnit: string | null,
    combinedPressureDUnit: string | null,
    combinedPressureEUnit: string | null

): React.ReactNode => {

    const value = point.value
    const channel = point.seriesName
    const serial = channel.slice(2)
    //const deviceName = loggers.filter(log => log.Serial === parseInt(serial))[0]?.DeviceName
    //console.log(deviceName)
    let gutermannChan = ""
    switch (channel.slice(0, 1)) {
        case 'A':
            gutermannChan = intl.formatMessage({ id: 'Flow A' })
            break
        case 'B':
            gutermannChan = intl.formatMessage({ id: 'Flow B' })
            break
        case 'C':
            gutermannChan = intl.formatMessage({ id: 'Pressure C' })
            break
        case 'D':
            gutermannChan = intl.formatMessage({ id: 'Pressure D' })
            break
        case 'E':
            gutermannChan = intl.formatMessage({ id: 'Pressure E' })
            break
        default:
            gutermannChan = channel.slice(0, 1)
            break
    }
    const siteDetailForLogger = loggerSiteDetails.filter(d => d.serial === parseInt(serial))[0]
    let unit: string | null = "";
    if (point.point.series?.axis) {

        const channelLetter = channel.slice(0, 2)
        if (!combineY) {
            const graphSettings = unitsAndValues.filter(item => item.serial === parseInt(point.point.data.serial))[0]?.graphSettings
            if (channelLetter === 'A ') {
                unit = graphSettings?.flowAUnit
            } else if (channelLetter === 'AT') {
                unit = graphSettings?.flowATotalUnit
            } else if (channelLetter === 'AC') {
                unit = graphSettings?.flowAConsumptionUnit
            }

            else if (channelLetter === 'B ') {
                unit = graphSettings?.flowBUnit
            } else if (channelLetter === 'BT') {
                unit = graphSettings?.flowBTotalUnit
            } else if (channelLetter === 'BC') {
                unit = graphSettings?.flowBConsumptionUnit
            }

            else if (channelLetter === 'C ') {
                unit = graphSettings?.pressureCUnit
            }
            else if (channelLetter === 'D ') {
                unit = graphSettings?.pressureDUnit
            }
            else if (channelLetter === 'E ') {
                unit = graphSettings?.pressureEUnit
            }
        } else {

            if (channelLetter === 'A ') {
                unit = combinedFlowAUnit
            } else if (channelLetter === 'AT') {
                unit = combinedTotalAUnit
            } else if (channelLetter === 'AC') {
                unit = combinedConsumptionAUnit
            } else if (channelLetter === 'B ') {
                unit = combinedFlowBUnit
            } else if (channelLetter === 'BT') {
                unit = combinedTotalBUnit
            } else if (channelLetter === 'BC') {
                unit = combinedConsumptionBUnit
            } else if (channelLetter === 'C ') {
                unit = combinedPressureCUnit
            } else if (channelLetter === 'D ') {
                unit = combinedPressureDUnit
            } else if (channelLetter === 'E ') {
                unit = combinedPressureEUnit
            }
        }
    }

    if (value || value === 0) {
        return (
            <div style={{zIndex: 10000000000} }>
                {/*{deviceName && <p>{`Device Name: ${deviceName}`}</p>}*/}
                <p>{window.location.hostname.includes('zonelog.net') ? `${intl.formatMessage({ id: 'Channel' })}: ${gutermannChan} ${serial}` : `${intl.formatMessage({ id: 'Channel' })}: ${channel}`}</p>
                {value.toString().length > 5 ? <p> {`Value: ${value.toFixed(3)} ${unit}`}</p> : <p> {`${intl.formatMessage({ id: 'Value' })}: ${value} ${unit}`}</p>}
                {siteDetailForLogger?.siteName && <p><FormattedMessage id="Site Name" />: {siteDetailForLogger.siteName}</p>}
                {siteDetailForLogger?.siteName && siteDetailForLogger?.siteRef !== 'Unallocated Devices' && <p><FormattedMessage id="Site Ref" />: {siteDetailForLogger.siteRef}</p>}
                <p>{moment(point.argument).format('Do MMM HH:mm:ss')}</p>

            </div>
        )
    } else {
        return (
            <div style={{ zIndex: 10000000000 }}>
                {/*{deviceName && <p>{`Device Name: ${deviceName}`}</p>}*/}
                <p>{window.location.hostname.includes('zonelog.net') ? `${intl.formatMessage({ id: 'Channel' })}: ${gutermannChan} ${serial}` : `${intl.formatMessage({ id: 'Channel' })}: ${channel}`}</p>
                <p>{intl.formatMessage({ id: 'Minimum value' })}: {point.rangeValue1} {unit}</p>
                <p>{intl.formatMessage({ id: 'Maximum value' })}: {point.rangeValue2} {unit}</p>
                {siteDetailForLogger?.siteName && <p><FormattedMessage id="Site Name" />: {siteDetailForLogger.siteName}</p>}
                {siteDetailForLogger?.siteName && siteDetailForLogger?.siteRef !== 'Unallocated Devices' && <p><FormattedMessage id="Site Ref" />: {siteDetailForLogger.siteRef}</p>}
                <p>{moment(point.argument).format('Do MMM HH:mm:ss')}</p>
            </div>
        )
    }
}